module.exports = __webpack_public_path__ + "img/df3917a751a885a365a47db40298de92.78a0b8a5.png";